// Shared imports
const { TYPES: modelTypes } = require('shared/model-types')
const { parseTemplate } = require('shared/model-helpers/meta-template')

function wrapArticle(article, streamMeta) {
  /**
   * The `meta` field is used to convey context and does not
   * represent persisted model data; move it to the streamItem
   * so that the context is retained, but separate from the article
   * @see https://redux.js.org/recipes/structuringreducers/normalizingstateshape
   */
  const {
    meta: articleMeta,
    ...normalizedArticle
  } = article
  return {
    type: modelTypes.ARTICLE,
    id: article['url_id'],
    article: normalizedArticle,
    meta: {
      // Handle interleaved streams; fall back to non-interleaved
      recId: streamMeta.urlRecId || streamMeta.recId,
      recPosition: articleMeta && articleMeta['rec_position'],
      recReason: getAndParseRecReason(articleMeta)
    }
  }
}

function wrapCollection(collection, streamMeta) {
  const {
    meta: collectionMeta,
    ...normalizedCollection
  } = collection
  return {
    type: modelTypes.MIX,
    id: collection.id,
    collection: normalizedCollection,
    meta: {
      // Handle interleaved streams; fall back to non-interleaved
      recId: streamMeta.mixRecId || streamMeta.recId,
      recReason: getAndParseRecReason(collectionMeta)
    }
  }
}

function wrapInterest(interest, streamMeta) {
  return {
    type: modelTypes.INTEREST,
    id: interest.key,
    interest,
    meta: {
      recId: streamMeta.interestRecId || streamMeta.recId
    }
  }
}

function wrapUser(user, streamMeta) {
  const {
    meta: userMeta,
    ...normalizedUser
  } = user
  return {
    type: modelTypes.USER,
    id: user.id,
    user: normalizedUser,
    meta: {
      // Handle interleaved streams; fall back to non-interleaved
      recId: streamMeta.userRecId || streamMeta.recId,
      recReason: getAndParseRecReason(userMeta)
    }
  }
}

function wrapFeedItem(feedItem, streamMeta = {}) {
  const modelType = feedItem.type
  switch (modelType) {
    case modelTypes.ARTICLE:
    case 'url':
      return wrapArticle(feedItem, streamMeta)
    case modelTypes.INTEREST:
      return wrapInterest(feedItem, streamMeta)
    case modelTypes.MIX:
      return wrapCollection(feedItem, streamMeta)
    case modelTypes.USER:
      return wrapUser(feedItem, streamMeta)
    default:
      if (modelType) {
        throw new Error(`Unsupported feedItem.type[${modelType}]`)
      }
      throw new Error(`Missing feedItem.type`)
  }
}

function wrapFeedStream(stream) {
  const streamMeta = stream.meta || {}
  return {
    items: stream.items.map(item => wrapFeedItem(item, streamMeta)),
    meta: streamMeta
  }
}

module.exports = {
  wrapArticle,
  wrapCollection,
  wrapFeedItem,
  wrapFeedStream
}

/**
 * @param {Object} [modelMeta]
 * @param {RawRecReason} [modelMeta.rec_reason]
 * @returns {ParsedRecReason}
 */
function getAndParseRecReason(modelMeta) {
  let recReason = modelMeta && modelMeta['rec_reason']
  if (recReason) {
    // Attach parsed meta-template to rec_reason
    return { ...recReason, html: parseTemplate(recReason) }
  }
}
